// import types
import type { SxProps, Theme } from '@mui/material';
import type { PrescriptionStatus } from 'generated/index';

// import constants
import {
  AMBER,
  AMBER_DARK,
  AMBER_LIGHT,
  GRAY,
  GRAY_LIGHT_TERTIARY,
  GRAY_SECONDARY,
  MINT,
  NEW_RED_LIGHT,
  PRIMARY,
  PRIMARY_LIGHT,
  RED_MUTED,
  RED_MUTED_LIGHT
} from 'constants/colors';

export const cardSx: SxProps<Theme> = {
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  borderRadius: '8px',
  px: 2.5,
  py: 2,
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)'
};

export const statusBarSx = (backgroundColor: string): SxProps<Theme> => ({
  width: 4,
  flexShrink: 0,
  alignSelf: 'stretch',
  borderRadius: '9999px',
  backgroundColor,
  mx: 1
});

export const topRowSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: 1,
  mb: 1.5
};

export const descriptionIconSx: SxProps<Theme> = {
  fontSize: 20,
  color: 'primary.main',
  flexShrink: 0,
  display: 'block'
};

export const statusChipSx = (status: PrescriptionStatus): SxProps<Theme> => ({
  height: 24,
  fontSize: '12px',
  fontWeight: 500,
  marginLeft: '4px',
  ...(status === 'ACTIVE' && {
    borderColor: MINT,
    color: PRIMARY,
    backgroundColor: PRIMARY_LIGHT
  }),
  ...(status === 'CONCEPT' && {
    borderColor: AMBER,
    color: AMBER_DARK,
    backgroundColor: AMBER_LIGHT
  }),
  ...(status === 'EXPIRED' && {
    borderColor: GRAY,
    color: GRAY_SECONDARY,
    backgroundColor: GRAY_LIGHT_TERTIARY
  })
});

export const urgencyChipSx: SxProps<Theme> = {
  height: 24,
  fontSize: '12px',
  fontWeight: 500,
  borderColor: NEW_RED_LIGHT,
  color: RED_MUTED,
  backgroundColor: RED_MUTED_LIGHT,
  '& .MuiChip-icon': {
    fontSize: 15,
    color: RED_MUTED,
    ml: '8px'
  }
};

export const metaRowSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: 2,
  color: 'text.secondary'
};

export const metaItemSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.5
};

export const smallIconSx: SxProps<Theme> = { fontSize: 14 };

export const chevronBoxSx: SxProps<Theme> = {
  flexShrink: 0,
  color: 'text.secondary',
  display: 'flex',
  alignSelf: 'center'
};

export const chevronIconSx: SxProps<Theme> = { fontSize: 24 };

export const chevronAnimatedSx = (expanded: boolean): SxProps<Theme> => ({
  ...chevronIconSx,
  transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
  transition: 'transform 0.2s ease'
});

export const expandedGridSx: SxProps<Theme> = {
  mt: 2,
  mx: -2.5,
  px: 2.5,
  borderTop: '2px solid',
  borderColor: 'divider',
  pt: 2
};
